<template>
    <component :is="component" :detectionData="detectionData" v-if="component"/>
</template>

<script>
export default {
    name: "DetectionDetailLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        detailLayout: '',
        detectionData: {default: () => {}},
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/detection/detail/DetectionDetailDefaultLayout')
                })

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.detailLayout) {
                return null
            }
            return () => import(`@/template/detection/detail/${this.detailLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
